"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.slice.js");

require("core-js/modules/es6.function.name.js");

require("core-js/modules/es6.array.from.js");

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));

require("react-day-picker/lib/style.css");

var _moment = _interopRequireDefault(require("moment"));

var _Input = require("../../Input");

require("./DateRangeInput.css");

var _DropDown = _interopRequireDefault(require("../DropDown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

_moment.default.updateLocale(_moment.default.locale(), {
  invalidDate: ''
});

var DateRangeInput = function DateRangeInput(_ref) {
  var modelBase = _ref.modelBase,
      dateRangeModel = _ref.dateRangeModel,
      change = _ref.change,
      onChange = _ref.onChange,
      _ref$isPastRange = _ref.isPastRange,
      isPastRange = _ref$isPastRange === void 0 ? true : _ref$isPastRange,
      _ref$initialRange = _ref.initialRange,
      initialRange = _ref$initialRange === void 0 ? {
    from: null,
    to: null
  } : _ref$initialRange;

  var _useState = (0, _react.useState)({
    from: null,
    to: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dateRange = _useState2[0],
      setDateRange = _useState2[1];

  (0, _react.useEffect)(function () {
    var range = {
      from: initialRange.from ? new Date(initialRange.from) : null,
      to: initialRange.to ? new Date(initialRange.to) : null
    };
    setDateRange(range);
  }, [initialRange]);
  var startMonth = (0, _moment.default)().startOf('months').subtract(isPastRange ? 1 : 0, 'months').toDate();

  var handleDayClick = function handleDayClick(day) {
    var range = _reactDayPicker.DateUtils.addDayToRange(day, dateRange);

    setDateRange(range);
    change("".concat(modelBase).concat(dateRangeModel), {
      from: Date.parse(range.from),
      to: Date.parse(range.to)
    });
    if (range.from && range.to) onChange({
      target: {
        value: range
      }
    });
  };

  var renderHeader = function renderHeader() {
    var from = (0, _moment.default)(dateRange.from).format('MMMM D, YYYY');
    var to = (0, _moment.default)(dateRange.to).format('MMMM D, YYYY');
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "date-range-input-header"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "selected-date-range"
    }, from && to ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, from), /*#__PURE__*/_react.default.createElement("div", null, to)) : /*#__PURE__*/_react.default.createElement("div", null, "Select a date range")));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "date-range-input"
  }, /*#__PURE__*/_react.default.createElement(_DropDown.default, {
    direction: "right",
    header: renderHeader(),
    pane: function pane() {
      return /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, {
        className: "date-range-selector",
        numberOfMonths: 2,
        selectedDays: [dateRange.from, dateRange],
        modifiers: {
          start: dateRange.from,
          end: dateRange.to
        },
        onDayClick: handleDayClick,
        month: startMonth
      });
    }
  }));
};

var _default = (0, _reactRedux.connect)(null, {
  change: _Input.formActions.change
})(DateRangeInput);

exports.default = _default;